<template>
    <div class="nav" :class="{active:navToggle}">
      <div class="no-path-scan" v-if="useItineraryStore().allPathsNumber == 0">
        <svg  @click.stop="showCamera()" class="map-favorites" width="41" height="58" viewBox="0 0 41 58" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="58" width="58" height="40" rx="20" transform="rotate(-90 0.5 58)" fill="#2E3D45"/>
            <path d="M15.75 32.75C15.75 32.5 16 32.25 16.25 32.25L16.75 32.25C17.0312 32.25 17.25 32.5 17.25 32.75L17.25 33.25C17.25 33.5312 17.0312 33.75 16.75 33.75L16.25 33.75C16 33.75 15.75 33.5312 15.75 33.25L15.75 32.75ZM15 36C14.1875 36 13.5 35.3437 13.5 34.5L13.5 31.5C13.5 30.6875 14.1875 30 15 30L18 30C18.8437 30 19.5 30.6875 19.5 31.5L19.5 34.5C19.5 35.3437 18.8438 36 18 36L15 36ZM18 34.5L18 31.5L15 31.5L15 34.5L18 34.5ZM24.25 33.75C24 33.75 23.75 33.5312 23.75 33.25L23.75 32.75C23.75 32.5 24 32.25 24.25 32.25L24.75 32.25C25.0312 32.25 25.25 32.5 25.25 32.75L25.25 33.25C25.25 33.5312 25.0312 33.75 24.75 33.75L24.25 33.75ZM23 36C22.1875 36 21.5 35.3437 21.5 34.5L21.5 31.5C21.5 30.6875 22.1875 30 23 30L26 30C26.8437 30 27.5 30.6875 27.5 31.5L27.5 34.5C27.5 35.3437 26.8438 36 26 36L23 36ZM26 34.5L26 31.5L23 31.5L23 34.5L26 34.5ZM15.75 24.75C15.75 24.5 16 24.25 16.25 24.25L16.75 24.25C17.0312 24.25 17.25 24.5 17.25 24.75L17.25 25.25C17.25 25.5312 17.0312 25.75 16.75 25.75L16.25 25.75C16 25.75 15.75 25.5312 15.75 25.25L15.75 24.75ZM13.5 23.5C13.5 22.6875 14.1875 22 15 22L18 22C18.8437 22 19.5 22.6875 19.5 23.5L19.5 26.5C19.5 27.3437 18.8437 28 18 28L15 28C14.1875 28 13.5 27.3437 13.5 26.5L13.5 23.5ZM15 23.5L15 26.5L18 26.5L18 23.5L15 23.5ZM27.5 24L27.5 25L26.5 25L26.5 24L27.5 24ZM26.5 23L26.5 22L27.5 22L27.5 23L26.5 23ZM25.5 22L25.5 25L24.5 25L24.5 26L27.5 26L27.5 28L21.5 28L21.5 25L22.5 25L22.5 23L21.5 23L21.5 22L25.5 22Z" fill="white"/>
          </svg>
        </div>
        <div @click="toggleNav()" class="favorites-outside">
          <div v-show="false && useItineraryStore().allPathsNumber > 1" @click="trashPath()" class="trash-icon">
            <img :src="trashBtn" alt="">
          </div>
          <div class="holder" v-if="processedPois.length > 0">
            <div v-show="!navToggle" class="icon flag">
              <img :src="flags" alt="">
            </div>
            <div v-show="navToggle" class="icon arrow">
              <img :src="exitArrow" alt="">
            </div>
            <div>{{t('favorites_menu.saved_destinations_title')}}</div>
            <span class="number">+{{ useItineraryStore().allPathsNumber }}</span>
          </div>
          <div class="map-favorites-container">
            <svg @click.stop="showCamera()" class="map-favorites" width="41" height="58" viewBox="0 0 41 58" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="58" width="58" height="40" rx="20" transform="rotate(-90 0.5 58)" fill="#2E3D45"/>
              <path d="M15.75 32.75C15.75 32.5 16 32.25 16.25 32.25L16.75 32.25C17.0312 32.25 17.25 32.5 17.25 32.75L17.25 33.25C17.25 33.5312 17.0312 33.75 16.75 33.75L16.25 33.75C16 33.75 15.75 33.5312 15.75 33.25L15.75 32.75ZM15 36C14.1875 36 13.5 35.3437 13.5 34.5L13.5 31.5C13.5 30.6875 14.1875 30 15 30L18 30C18.8437 30 19.5 30.6875 19.5 31.5L19.5 34.5C19.5 35.3437 18.8438 36 18 36L15 36ZM18 34.5L18 31.5L15 31.5L15 34.5L18 34.5ZM24.25 33.75C24 33.75 23.75 33.5312 23.75 33.25L23.75 32.75C23.75 32.5 24 32.25 24.25 32.25L24.75 32.25C25.0312 32.25 25.25 32.5 25.25 32.75L25.25 33.25C25.25 33.5312 25.0312 33.75 24.75 33.75L24.25 33.75ZM23 36C22.1875 36 21.5 35.3437 21.5 34.5L21.5 31.5C21.5 30.6875 22.1875 30 23 30L26 30C26.8437 30 27.5 30.6875 27.5 31.5L27.5 34.5C27.5 35.3437 26.8438 36 26 36L23 36ZM26 34.5L26 31.5L23 31.5L23 34.5L26 34.5ZM15.75 24.75C15.75 24.5 16 24.25 16.25 24.25L16.75 24.25C17.0312 24.25 17.25 24.5 17.25 24.75L17.25 25.25C17.25 25.5312 17.0312 25.75 16.75 25.75L16.25 25.75C16 25.75 15.75 25.5312 15.75 25.25L15.75 24.75ZM13.5 23.5C13.5 22.6875 14.1875 22 15 22L18 22C18.8437 22 19.5 22.6875 19.5 23.5L19.5 26.5C19.5 27.3437 18.8437 28 18 28L15 28C14.1875 28 13.5 27.3437 13.5 26.5L13.5 23.5ZM15 23.5L15 26.5L18 26.5L18 23.5L15 23.5ZM27.5 24L27.5 25L26.5 25L26.5 24L27.5 24ZM26.5 23L26.5 22L27.5 22L27.5 23L26.5 23ZM25.5 22L25.5 25L24.5 25L24.5 26L27.5 26L27.5 28L21.5 28L21.5 25L22.5 25L22.5 23L21.5 23L21.5 22L25.5 22Z" fill="white"/>
            </svg>
          </div>
        </div>
      <div class="path-inside">
        <div class="paths-nav">
            <img v-if="useItineraryStore().allPathsNumber > 1" @click="changePath('left')" :src="leftArrow" alt="">
            <span>{{ t('mobile.path') }} {{ useItineraryStore().selectedPathNumber + 1}}</span>
            <img v-if="useItineraryStore().allPathsNumber > 1" @click="changePath('right')" :src="rightArrow" alt="">
        </div>
        <div class="info" v-if="processedPois.length > 0">
          <div class="path-title">{{ t(processedPois[0].properties.id + ".title") }} -
          {{ t(processedPois[processedPois.length - 1].properties.id + ".title")}}</div>
          <div class="number">{{ t('mobile.numsidenav') }}: {{ processedPois.length }}</div>
        </div>
        <div class="options">
            <div @click="copyTextToClipboard" class="btn empty-btn"><img :src="shareButtonIcon" alt=""><span v-show="!copiedText">{{ t('mobile.share_btn') }}</span><span v-show="copiedText">URL kopiran</span></div>
            <div  v-show="useItineraryStore().allPathsNumber > 1" @click="deleteSet()" class="btn empty-btn"><img :src="trashBtn" alt=""><span v-show="!copiedText">{{ t('mobile.delete_set') }}</span></div>
            <div v-if="false && useItineraryStore().showNavigation" class="btn full-btn"><img :src="navigationIcon" alt=""><a :href="useItineraryStore().googlemapsDirectionsLink" target="_blank">{{ t('mobile.navigation') }}</a></div>
        </div>
        <div class="pois-scroll">
            <div class="poi starting-point">
            <img :src="currentLocation" alt="">
            <div class="content">
              <p class="address">{{ t('general.you_are_here') }}</p>
              <h3>{{ t('general.starting_position') }}</h3>
            </div>
          </div>
          <div v-for="poi in processedPois" :key="poi.id" @click="goToPoi(poi)" class="poi" :class="'style-' + poi.properties.categories[0]" >
                <!--poi.properties.presentation-->
                <div class="bgi" :style="{backgroundImage:`url(${poi.thumb[0]})`}"></div>
                <div class="info">
                <div class="categories">
                  <img v-for="categoryIcon in poi.processedCategories" :key="categoryIcon.category" :class="'style-' + categoryIcon.category" :src="categoryIcon.icon" alt="">
                  </div>
                <h3>{{ t(poi.properties.id+".title")}}</h3>
              </div>
            </div>
        </div>    
    </div>
  </div>
</template>
<script setup>
import { ref,onMounted,watch,computed, defineExpose  } from 'vue'
import { useItineraryStore } from '@/stores/itinerary-stores.ts'
import {returnThumb} from '@/utils/helpers.js';
import currentLocation from '@/assets/current-location-icon.svg'
import leftArrow from '@/assets/left-arrow.svg'
import rightArrow from '@/assets/right-arrow.svg'
import { useI18n } from "vue-i18n";
import flags from '@/assets/flags.svg'
import exitArrow from '@/assets/right-arrow.svg'

import missingImageCulture from '@/assets/categoryBg/image-missing-culture.svg'
import missingImageNature from '@/assets/categoryBg/image-missing-nature.svg'
import missingImageTourism from '@/assets/categoryBg/image-missing-tourism.svg'
import missingImageSport from '@/assets/categoryBg/image-missing-sport.svg'

import navigationIcon from '@/assets/buttons/navigation.svg'
import shareButtonIcon from '@/assets/buttons/share-button.svg'

//import trashBtn from '@/assets/trash-btn.svg'
import trashBtn from '@/assets/trash.svg'

const { t } = useI18n();
const images = ref([]);
let itinterary = '';
let selectedPath = '';
const navToggle = ref(true);
defineExpose({ navToggle });
const fullLink = ref('');
const copiedText = ref(false);
const publicUrl = import.meta.env.VITE_PUBLIC_URL;
const root = window.location;

const minPoiZoom = 15;

onMounted(() => {
    itinterary = useItineraryStore().itinerary;
    selectedPath = useItineraryStore().selectedPath;
});

function toggleNav() {
  navToggle.value = !navToggle.value;
}

function changePath(side) {
  copiedText.value = false;
  if(useItineraryStore().blockNavigation){
    return;
  }
  const store = useItineraryStore();
  const currentIndex = store.selectedPathNumber;

  if(store.allPathsNumber - 1 == currentIndex && side != 'left'){
    store.setActiveSetByIndex(0);
    return;
  }

  if(side == 'left') {
    if(currentIndex == 0) {
      store.setActiveSetByIndex(store.allPathsNumber - 1);
      return;
    }
    store.setActiveSetByIndex(currentIndex - 1);
  } else {
    if(currentIndex >= store.allPathsNumber - 1) {
      store.setActiveSetByIndex(0);
    } else {
      store.setActiveSetByIndex(currentIndex + 1);
    }
  }
}

function goToPoi(poi) {
  navToggle.value = false;
  let curZoom = useItineraryStore().map.getZoom();
  if( curZoom < minPoiZoom){
    curZoom = minPoiZoom
  }
  useItineraryStore().map.flyTo({
    center: poi.geometry.coordinates,
    zoom: curZoom,
    essential: true
  });

  useItineraryStore().activePoiProperties = poi.properties
  useItineraryStore().activePoi = poi.properties.id
}

function showCamera() {
  if(navToggle.value){
    toggleNav();
  }
  useItineraryStore().showCamera = true;
}



const processedPois = computed(() => {
  const itinerary = useItineraryStore().itinerary;
  const selectedPath = useItineraryStore().selectedPath;
  const VITE_MIZA_REPO_URL = import.meta.env.VITE_MIZA_REPO_URL;
  if(itinerary[selectedPath] === undefined) {
    return [];
  }
 
  return itinerary[selectedPath].pois.map((poi,index) => {
    const categoriesToDisplay = poi.properties.categories.slice(1);
    let url = VITE_MIZA_REPO_URL + useItineraryStore().currentDestination + '/';
    let thumb = returnThumb(url,'m',poi.properties.presentation); // Ensure this is computed or fetched as needed

    if(!thumb) {
      thumb = [];
      switch (poi.properties.categories[0]) {
        case '80':
          thumb.push(missingImageNature);
          break;
        case '81':
          thumb.push(missingImageSport);
          break;
        case '82':
          thumb.push(missingImageCulture);
          break;
        case '83':
          thumb.push(missingImageTourism);
          break;
        default:
          thumb.push(missingImageCulture);
          break;
      }
    }

    const categoryIcons = categoriesToDisplay.map(category => ({
      category,
      icon: useItineraryStore().returnCategoryIcon(category)
    }));
    return { ...poi, processedCategories: categoryIcons, thumb };
  });
});

const copyTextToClipboard = async () => {
  const VITE_PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL;
  let text = 'https://' + window.location.host + VITE_PUBLIC_URL + '?' + useItineraryStore().selectedPath;
  console.log("text: ",text);
  try {
    await navigator.clipboard.writeText(text);
    copiedText.value = true;
  } catch (err) {
    console.error('Failed to copy: ', err);
  }
};

function deleteSet(){
  const store = useItineraryStore();
 
  //return;
  // Get the current path name and key
  const pathKey = store.allKeys[store.selectedPathNumber];
  const pathName = 'path_' + pathKey;
  if(store.allKeys.length < 2) return

  try {
    // Remove the path line layer if it exists
    if (store.map.getLayer(pathName)) {
      store.map.removeLayer(pathName);
    }
    
    // Remove the path line source if it exists
    if (store.map.getSource(pathName)) {
      store.map.removeSource(pathName);
    }
    
    // Store the path data before deleting it (we need the POI IDs)
    const pathToDelete = store.itinerary[pathKey];
    const poisToDelete = pathToDelete?.pois || [];
    const poiIdsToDelete = poisToDelete.map(poi => poi.properties.id);
    console.log("pathToDelete: ", pathToDelete);
    
    // Remember the current index before deletion
    const currentIndex = store.selectedPathNumber;
    
    // Delete the path from the itinerary
    delete store.itinerary[pathKey];
    
    // Update local storage
    localStorage.setItem("simpl-pwa-app-data", JSON.stringify(store.itinerary));
    
    //location.reload();
    // Update the store with the new keys
    let allKeys = Object.keys(store.itinerary);
    store.allKeys = allKeys;
    store.allPathsNumber = allKeys.length;

    store.selectedPath = store.allKeys[0];
    store.selectedPathNumber = 0;
    
    // Handle the case when there are no paths left
    // drejc not needen anymore
    /*
    if (allKeys.length === 0) {
      store.selectedPathNumber = 0;
      store.selectedPath = null;
      store.currentPathDestination = '';
      
      // Remove the markers layer and source since there are no paths left
      if (store.map.getLayer('markersPath')) {
        store.map.removeLayer('markersPath');
      }
      if (store.map.getSource('pathSource')) {
        store.map.removeSource('pathSource');
      }
      if(useItineraryStore().map.getLayer('markersDestination')) { 
        useItineraryStore().map.setLayoutProperty("markersDestination", 'visibility', 'visible');
        useItineraryStore().map.setLayoutProperty("clusters", 'visibility', 'visible');

        if(useItineraryStore().geolocateControl != null) {
          useItineraryStore().geolocateControl.trigger();
        }
      }
      return;
    }
    */
  }catch{
    return false;
  }
}

</script>
<style scoped lang="scss">
@import '@/assets/styles/mixins.scss';
.nav {
    width: 400px;
    right: -400px;
    position: absolute;
    bottom: 0;
    height: calc(100% - 70px);
    background-color: #fff;
    z-index: 100;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    color:#000;
    transition:0.5s all;
    padding: 8px 16px 0 38px;
    .number {
      margin-top:10px;
    }
    &.active {
      right:0;
      .favorites-outside {
        left: -22px;
      }
    }
    .paths-nav {
        padding:32px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;
        //background-color: #f5f5f5;
    }
    .options {
        display: flex;
        width: 100%;
        margin:16px 0;
        height: 50px;
        //background-color: #f5f5f5;
        gap: 10px;
        .btn {
          position: relative;
          border-radius: 50px;
          img {
            width: 19px;
            margin-right: 10px;
            /*position:absolute;
            left: 18px;
            top: 15px;*/
          }
        }
        .empty-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          border:2px solid #2E3D45;
          line-height: 46px;
          text-align: center;
          width:100%;
          background: #fff;
        }
        .full-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          border:2px solid #2E3D45;
          line-height: 46px;
          text-align: center;
          width:100%;
          background: #2E3D45;
          color:#fff;
          a {
            color:#fff;
            text-decoration: none;
          }
        
        }
    }
    .info {
        //padding: 16px;
        .path-title {
          font-size: 12px;
          font-weight: 700;
          line-height: 14px;
        }
        .number {
          font-size: 10px;
          font-weight: 400;
          line-height: 14px;
        }
        //background-color: #f5f5f5;
      }
    .pois-scroll {
        height: calc(100vh - 280px);
        overflow-y: auto;
        padding-right:8px;
    }
}

.trash-icon {
  margin-top: 20px;
  img {
    width:100%;
    transform: rotate(-180deg);
  }
}


.pois-scroll {
        height: 810px;
        overflow-y: scroll;
        margin-top: 20px;
        //padding-left:20px;
        //padding-right:15px;
        &::-webkit-scrollbar {
          width: 50px;
          height: 50px;
          background:-webkit-linear-gradient(0, blue 50%, white 100%);
        }
  
        &::-webkit-scrollbar-track {
          border-radius: 10px;
          background-color: #F5F5F5;
        }
  
        &::-webkit-scrollbar {
          width: 10px;
          background-color: #F5F5F5;
        }
  
        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background-color: var(--culture-color-start);
        }
  
        .poi {
          
            display: flex; 
            margin-bottom: 16px;
            position: relative;
            .bgi {
              background-position: center;
              background-size: cover;
              margin-right:15px;
            }
            .info {
              padding-right: 5px;
              margin-top: 8px;
              h3 {
                font-size: 18px;
                font-weight: 700;
                line-height: 20px;
                margin-top:10px;
              
              }
            }
            &.starting-point {
              border-top:2px solid #2E3D45;
              border-bottom:2px solid #2E3D45;
              border-right:2px solid #2E3D45;
              border-radius: 24px 20px 20px 0px;
              display: flex;
              align-items: center;
              .content {
                padding-top:0;
              }
              img {
                width:45px;
              }
              &:after {
                content:"";
                position: absolute;
                bottom:-2px;
                left: -1px;
                width: 22px;
                height: 4px;
                background-color: #fff;
              }
            }
            &.style-80 {
              border:2px solid var(--nature-color-start);
                  border-radius: 22px;
                
                .bgi {
                    background-color:var(--nature-color-start);
                    //border-right: 8px solid var(--nature-color-start);
                }
            }
            &.style-81 {
              border:2px solid var(--sport-color-start);
                  border-radius: 22px;
                .bgi {
                    background-color:var(--sport-color-start);
                    //border-right: 8px solid var(--sport-color-start);
                }
            }
            &.style-82 {
              border:2px solid var(--culture-color-start);
                border-radius: 22px;
                .bgi {
                    background-color:var(--culture-color-start);
                    //border-right: 8px solid var(--culture-color-start);
                }
            }
            &.style-83 {
                border:2px solid var(--turism-color-start);
                    border-radius: 22px;
                .bgi {
                    background-color:var(--turism-color-start);
                    //border-right: get-vw(8px) solid var(--turism-color-start);
                }
            }
            .content {
                padding:10px 0 0 14px;
                h3 {
                    font-size: 20px;
                    font-weight: 700;
                    line-height: 25px;
                    margin:0;
                }
                .address {
                    font-weight: 500;
                    font-size: 15px;   
                    margin:0;
                }
            }
            .bgi {
                min-width:127px;
                height: 99px;
                border-radius: 20px;
                height: auto;
                min-height: 97px;
            } 
        }
    }
    .options {
        display: flex;
    }

    .categories {
    display: flex;
    gap: 5px;
  
    img {
      width: 22px;
      padding: 5px;
      border-radius: 50%;
    }
  
    .style-80,
    .style-84,
    .style-85,
    .style-86,
    .style-104 {
      background: var(--nature-color-gradient);
    }
  
    .style-81,
    .style-87,
    .style-88,
    .style-89,
    .style-99 {
      background: var(--sport-color-gradient);
    }
  
    .style-82,
    .style-90,
    .style-91,
    .style-92,
    .style-98,
    .style-100 {
      background: var(--culture-color-gradient);
    }
  
    .style-83,
    .style-93,
    .style-94,
    .style-95,
    .style-101,
    .style-102,
    .style-103 {
      background: var(--turism-color-gradient);
    }
  }

  .favorites-outside {
  pointer-events: none;
  writing-mode: vertical-rl;
  transform: rotate(-180deg);
  margin-right: 0;
  margin-bottom: 90px;
  left: -70px;
  bottom:20px;
  position: absolute;
  z-index: 1;
  .holder {
    pointer-events: all;
    background-color: #fff;
    display: flex;
    line-height: 0;
    align-items: center;
    border: 2px solid #2E3D45;
    border-radius: get-vw(50px);
    padding: 20px 6px 20px 8px;

    .icon {
      display: flex;
      align-items: center;
      margin-right: 5px;
      rotate: 180deg;
      margin-bottom: 15px;
      img {
        width: 20px;
        height: 20px;
      }
    }
  }

  .map-favorites-container {
    position: absolute;
    bottom: 230px;
    left: -0.3vw;
    svg {
      pointer-events: all;
      width: 46px;
      height: 63px;
    }
  }
}

.no-path-scan {
  position: absolute;
  bottom:0;
  width:100px;
  height:100px;
  left:-80px;
  z-index: 999;
}

@media (max-width: 600px) {
  .favorites-outside {
    left: -50px;
  }

}

@media (max-width: 484px) {
  .nav {
    width: 90%;
    right: -90%;
  }
}

@media (min-width: 485px) {
  .nav {
    width: 450px;
    right: -450px;
  }
}

@media (max-width: 400px) {
  .nav {
    width: 90%;
    right: -90%;
    padding: 4px 8px 0 25px;
  }
  .pois-scroll .poi .bgi {
    min-height: 77px;
  }
}

</style>